import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'


// 3rd party plugins
import '@axios'
import '@/libs/vue-select'
import '@/libs/sweet-alerts'


// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)
// import core stylesZ
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// import assets styles
require('@/assets/css/style.css')

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
// Axios Mock Adapter
import '@/@fake-db/db';

import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

Vue.use(require('vue-moment'));
 
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
